const importWizard = {
  columnMappings: "Column Mappings",
  discardedRows: "Discarded Rows",
  fieldInformation: "Field Information",
  generate_data: "Generate Data",
  imported_data: "Imported Value",
  your_data: "Your Data",
  optional_field: "Optional Field",
  combine_fields: "Combine Fields",
  required_field: "Required Field",
  autofill_address: "Autofill Address",
  leave_blank: "Leave Blank",
  mapped_vehicle: "Mapped Vehicle",
  invalid_field: "Invalid {{field}}",
  data_preview: "Data Preview",
  original_value: "Original Value",
  combined_field: "Mutiple Fields",
  update_value: "Update Value",
  replace_all: "Replace All",
  auto_generated: "Auto-Generated",
  duplicate_records: "Duplicate Records Removed: {{count}}",
  csvField: "Column",
  trailingCharacters: "Trailing Characters",
  combinedValue: "Combined Value",
  property_address: "Property Address",
  correction_title: "Correction Required",
  fieldList: {
    title: "Field List",
    progress:
      "{{confirmedRequired}} out of {{totalRequired}} required fields mapped ({{confirmedTotal}} out of {{totalFields}} total)",
    entity_fields: "{{entity}} Fields",
    vehicle_fields: "Vehicle Fields",
    contact_fields: "Contact Fields",
    location_fields: "Location Fields",
  },
  preview_title: "{{entity}} Import Preview",
  total_records: "Total Records: {{count}}",
  failedImports: {
    title:
      "Some {{entity}} failed to import. Please review the failed records and resubmit them. ({{count}} remaining)",
    row_error: "Row {{row}}: {{error}}",
  },
  validationWidget: {
    generate_data: "All {{entity}} will be imported with the value below",
    remaining_errors: "Remaining Validation Errors: {{count}}",
    original_value: "Original Value",
    new_value: "New Value",
    update_value: "Update Value",
    replace_all: "Replace All",
  },
  processingVehicleData:
    "Processing Vehicle Data. This process may take a while for large data sets.",
  saveColumnMappingsHelper:
    "Save your column mappings for this data source for future use: {{name}}",
  downloadDiscardedRowsHelper:
    "All of your discarded rows will be downloaded as a CSV file.",
  uploadCSVHelper: "Upload a CSV file with the records you want to import",
  downloadCSVTemplateHelper:
    "If you prefer to map your data in your spreadsheet editor, you can import our CSV template to copy your data into.  For best results, do not modify the first two rows of the CSV template.",
  downloadCSVTemplateButton: "Download CSV Template",
  noSavedMappings: "No Saved Mappings",
  savedMappingsHelper:
    "If you have previously imported data from this source, select your saved mapping to use for this import",
  saveMappingNameExists: "Mapping name already exists",
  steps: {
    upload: "Upload and Define",
    map: "Map and Validate",
    preview: "Review and Import",
  },
  buttons: {
    upload_submit: "Continue to Mapping",
    map_submit: "Complete Mapping and Preview",
    upload_cancel: "Return to {{entity}}",
    map_cancel: "Return to Upload",
    preview_cancel: "Return to Mapping",
    discard_failed_import: "Discard Failed Import",
    clear_mapping: "Clear Mapping",
    confirm_mapping: "Confirm Mapping",
    validate_all: "Validate All Mapped Fields",
    complete_submit: "Import Additional {{entity}}",
    map_vehicle_data: "Map Vehicle Data",
    add_combined_field: "+ Combine Additional Field",
    map_combined_fields: "Map Combined Fields",
  },
  permitTypeLabel: "Permit Type: {{name}}",
  importFileLabel: "Import File: {{name}}",
  remaining_errors: "Remaining Validation Errors: {{count}}",
  alerts: {
    csv_import_tips: {
      title: "CSV Import Tips",
      p1: "If you have errors such as too many or not enough fields, you can fix your data in the next step, or you can modify the data in your spreadsheet and re-upload it.",
      p2: "Usually, these errors are caused by commas in your data cells or by having rows that are longer than the header row.",
      p3: "First check your data and make sure that there is no data in columns which do not have a header.",
      p4: "If you have commas in your data, you can remove them or use a different delimiter such as | when you export your CSV.",
    },
    template_recognized: {
      title: "CSV Template Recognized",
      p1: "The imported CSV template has been recognized.",
      p2: "You can now proceed to validate and import your data.",
    },
    perfect_parse: {
      title: "CSV Data Imported",
      p1: "Your CSV data has been imported without encountering any formatting issues!",
      p2: "You can now proceed to map your data to the system fields.",
    },
    import_report: {
      title: "Import Complete",
      p1: "You have successfully imported {{successCount}} records.",
      p2: "If you want to download a PDF or CSV of your imported records, use the three-dot menu in the top right corner of this panel.",
    },
    discarded_rows: {
      title: "Discarded Rows",
      p1: "There were {{discardedCount}} rows that were discarded.  You can download the rows you discarded as a CSV file for your records below",
    },
    welcome: {
      title: "Welcome to the {{entity}} Migration Wizard",
      p1: "In the first step, you will configure your import and upload your CSV data.",
    },
    invalid_values: {
      title: "Invalid Values Detected",
      p1: "Some values in this column do not meet the required format or constraints.",
      p2: "Please review and correct the data before proceeding.",
    },
    validation_success: {
      title: "Validation Successful",
      p1: "All values for this field are valid.",
      p2: "You can proceed to the next field.",
    },
    map_tutorial: {
      title: "Field Mapping",
      p1: "In this step, we will map and validate your data against our system fields and requirements.",
      p2: "You can select a system field from the left panel and assign it a column from your imported data using the dropdown menu above. Some fields may have been mapped automatically based on the column name. You will still need to validate the data and correct any errors.",
      p3: 'If we made a mistake, you can select the field and click "Clear Mapping". You will then be able to map it manually.',
      p4: 'Once you have validated the data for a field, click "Confirm Mapping". to proceed to the next field.',
      p5: 'Detailed information about how to handle each field can be found in the "Field Details" section on the right.',
      p6: "In addition to your fields, the dropdown at the top of this column also provides a few actions depending on the field.",
      p7: "Generate Data: You can import all of your records with a specific value for this field.",
      p8: "Autofill Address: You can autofill the address for this field with the property address.",
      p9: "Smart Map Vehicle: If you have a single column which contains two or more of the following vehicle data types: Make, Model, Color, or Year, you can extract this data into separate fields.",
      p10: "Leave Blank: You can leave this field blank for all records.",
    },
    mapping_complete: {
      title: "Mapping Complete",
      p1: "You have successfully mapped all of the fields in your imported data.",
      p2: "You can now proceed to review your data and confirm the import.",
    },
    duplicate_records: {
      title: "Duplicate Records Removed",
      p1: "We discarded {{discardedCount}} duplicate rows from your data.  You can download any discarded rows as a CSV file after you import your data.",
    },
    extract_vehicle_instructions: {
      title: "Extracting Vehicle Data",
      p1: "If you have a single column which contains two or more of the following vehicle data types: Make, Model, Color, or Year, you can extract this data into separate fields.",
      p2: 'You can select a the field from your data which contains the vehicle data and click the "Extract" button. The data will be extracted into separate fields and validated.',
      p3: "If the data is not formatted correctly, you will be given the opportunity to correct the data or map it to the correct fields manually.",
    },
    fields: {
      permitNumber: {
        info: {
          p1: "If you have assigned specific permit numbers, you can provide them here",
        },
        optional: {
          p1: 'If you do not assign permit numbers, you can select "Leave Blank" from the dropdown menu and we will assign each permit a unique number automatically in our system',
        },
      },
      name: {
        info: {
          p1: "This field holds the name of the entity",
          p2: "This is the primary identifier for the record",
        },
        required: {
          p1: "This field must contain a value to create the entity",
          p2: "If the name is not available, you can use 'Generate Data' to autofill a value for all your records.",
        },
      },
      description: {
        info: {
          p1: "This field holds a description of the entity",
          p2: "This is an optional field that provides additional context about the record",
        },
        optional: {
          p1: 'If you do not have description information, you can select "Leave Blank" from the dropdown menu',
        },
      },
      type: {
        info: {
          p1: "This field describes the type or category of the entity",
          p2: "Valid types vary depending on the entity being imported",
        },
        required: {
          p1: "This field must contain a value to create the entity",
          p2: "If the type is not available, you can use 'Generate Data' to autofill a value for all your records.",
        },
      },
      externalID: {
        info: {
          p1: "This field holds an external identifier for the entity",
          p2: "This can be used to reference the entity in external systems",
        },
        optional: {
          p1: 'If you do not have external ID information, you can select "Leave Blank" from the dropdown menu',
        },
      },
      status: {
        info: {
          p1: "This field describes the current status of the entity",
          p2: "Valid statuses: Active, Disabled, Expired, Pending Payment, and Pending Approval",
        },
        required: {
          p1: "This field must contain a value to create the entity",
          p2: "If the status is not available, you can use 'Generate Data' to autofill a value for all your records.",
          p3: "We recommend using 'Active' as the status for imported records.",
        },
      },
      startTime: {
        info: {
          p1: "The start time is the first day the entity is valid",
          p2: "In the case of temporary entities, it can also contain a time",
        },
        required: {
          p1: "This field must contain a value to create the entity",
          p2: "If the start time is not available, you can use 'Generate Data' to autofill a value for all your records.",
        },
      },
      endTime: {
        info: {
          p1: "The end time is the last day the entity is valid",
          p2: "In the case of temporary entities, it can also contain a time",
        },
        required: {
          p1: "This field must contain a value to create the entity",
          p2: "If the end time is not available, you can use 'Generate Data' to autofill a value for all your records.",
        },
      },
      make: {
        info: {
          p1: "If the entity is for a specific vehicle, you can provide the make here",
          p2: "We will attempt to validate the make against the most common vehicle manufacturers provided by the NHTSA",
        },
        optional: {
          p1: 'If you do not have make information, you can select "Leave Blank" from the dropdown menu and we will assign each record a make of "Unknown"',
        },
      },
      model: {
        info: {
          p1: "If the entity is for a specific vehicle, you can provide the model here",
          p2: "A comprehensive list of vehicle models for the provided make is available in the dropdown menu",
        },
        optional: {
          p1: 'If you do not have model information, you can select "Leave Blank" from the dropdown menu and we will assign each record a model of "Unknown"',
        },
      },
      year: {
        info: {
          p1: "If the entity is for a specific vehicle, you can provide the year here",
        },
        optional: {
          p1: 'If you do not have year information, you can select "Leave Blank" from the dropdown menu and we will assign each record a year of "Unknown"',
        },
      },
      color: {
        info: {
          p1: "If the entity is for a specific vehicle, you can provide the color here",
          p2: "We will attempt to validate the color against common vehicle colors provided by the NHTSA.  If the vehicle color is not recognized, you can choose the closest match from the dropdown menu",
        },
        optional: {
          p1: 'If you do not have color information, you can select "Leave Blank" from the dropdown menu and we will assign each record a color of "Unknown"',
        },
      },
      vin: {
        info: {
          p1: "If the entity is for a specific vehicle, you can provide the Vehicle Identification Number (VIN) here",
        },
        optional: {
          p1: 'If you do not have VIN information, you can select "Leave Blank" from the dropdown menu and we will assign each record a VIN of "Unknown"',
        },
      },
      plate_number: {
        info: {
          p1: "If the entity is for a specific vehicle, you can provide the license plate number here",
          p2: "License plate information can be used by the tower in place of a physical permit",
        },
        optional: {
          p1: 'If you do not have license plate number information, you can select "Leave Blank" from the dropdown menu and we will assign each record a plate number of "Unknown"',
        },
      },
      plate_state: {
        info: {
          p1: "If the entity is for a specific vehicle, you can provide the license plate state here",
        },
        optional: {
          p1: 'If you do not have license plate state information, you can select "Leave Blank" from the dropdown menu and we will assign each record a plate state of "Unknown"',
        },
      },
      contact_name: {
        info: {
          p1: "This field holds the name of the contact person",
        },
        required: {
          p1: "This field must contain a value to create the entity",
          p2: "If the contact name is not available, it will be assigned a default value of 'Unknown Contact'",
        },
      },
      street: {
        info: {
          p1: "This field holds the street address portion of the address",
        },
        optional: {
          p1: 'If you would like to autofill the address of this property, you can select "Autofill Address" from the dropdown menu',
          p2: 'Alternatively, if you do not want to list an address, you can select "Leave Blank"',
        },
        required: {
          p1: "This field must contain a value to create the entity",
        },
      },
      city: {
        info: {
          p1: "This field holds the city portion of the address",
        },
        optional: {
          p1: 'If you would like to autofill the city of this property, you can select "Autofill Address" from the dropdown menu',
          p2: 'Alternatively, if you do not want to list a city, you can select "Leave Blank"',
        },
        required: {
          p1: "This field must contain a value to create the entity",
        },
      },
      stateCode: {
        info: {
          p1: "This field holds the state or province",
        },
        optional: {
          p1: 'If you would like to autofill the state of this property, you can select "Autofill Address" from the dropdown menu',
          p2: 'Alternatively, if you do not want to list a state, you can select "Leave Blank"',
        },
        required: {
          p1: "This field must contain a value to create the entity",
        },
      },
      postalCode: {
        info: {
          p1: "This field holds the postal code (ZIP code) of the address",
        },
        optional: {
          p1: 'If you would like to autofill the postal code of this property, you can select "Autofill Address" from the dropdown menu',
          p2: 'Alternatively, if you do not want to list a postal code, you can select "Leave Blank"',
        },
        required: {
          p1: "This field must contain a value to create the entity",
        },
      },
      countryCode: {
        info: {
          p1: "This field holds the country code",
          p2: "Valid country codes: US (United States) and CA (Canada)",
        },
        required: {
          p1: "This field must contain a value to create the entity",
          p2: "If the country code is not available, you can use 'Generate Data' to autofill a value for all your records.",
        },
      },
      unit: {
        info: {
          p1: "This field holds the unit, suite, or apartment number",
        },
        optional: {
          p1: 'If your address does not have a unit, suite, or apartment number, you can select "Leave Blank"',
        },
      },
      primaryEmail: {
        info: {
          p1: "This field holds the email address of the contact",
          p2: "If provided, you will be able to configure automated email notifications for this contact",
        },
        optional: {
          p1: 'If you do not have email information, you can select "Leave Blank" from the dropdown menu',
          p2: "If provided, the email address must be valid",
        },
      },
      primaryPhone: {
        info: {
          p1: "This field holds the phone number of the contact",
          p2: "If provided, you will be able to configure automated SMS notifications for this contact",
        },
        optional: {
          p1: 'If you do not have phone number information, you can select "Leave Blank" from the dropdown menu',
          p2: "If provided, the phone number must be a valid 10 digit phone number",
        },
      },
      billingCustomer: {
        info: {
          p1: "This field holds the billing customer key",
          p2: "This is used to associate a property with the appropriate pricing plan in TOPS",
        },
        optional: {
          p1: 'This is a required field in TOPS. If you are importing a property from another system, you can select "Leave Blank" from the dropdown menu',
        },
      },
      notes: {
        info: {
          p1: "This field holds additional notes about the entity",
          p2: "This is a free-text field for any additional information you want to store",
        },
        optional: {
          p1: 'If you do not have notes, you can select "Leave Blank" from the dropdown menu',
        },
      },
      propertyName: {
        info: {
          p1: "This field holds the name of the property",
        },
        required: {
          p1: "This field must contain a value",
        },
      },
    },
  },
};

export default importWizard;
